import { useNavigate } from 'react-router-dom';
import { useGameContext } from '../contexts/GameContext';
import { GameScenarioContent } from '../types/ScenarioManagement';

export const useGameFlow = () => {
  const navigate = useNavigate();
  const { gameState, setGamePhase, resetGame } = useGameContext();

  const canProceedFromCEO = () => {
    return true;
  };

  const canProceedFromInvestments = () => {
    // If scenario skips investments, we don't need any investments selected
    const selectedScenario = gameState.selectedScenario;
    const gameContent = selectedScenario?.content as GameScenarioContent;
    if (gameContent?.gameSettings?.skipInvestments) {
      return true;
    }
    return gameState.selectedInvestments.length > 0;
  };

  const canProceedFromIncidents = () => {
    // Check if we have incident responses
    return gameState.incidentResponses.length > 0;
  };

  const navigateToCEO = () => {
    setGamePhase('intro');
    navigate('/intro');
  };

  const navigateToInvestments = () => {
    if (canProceedFromCEO()) {
      // Check if current scenario should skip investments
      const selectedScenario = gameState.selectedScenario;
      const gameContent = selectedScenario?.content as GameScenarioContent;
      if (gameContent?.gameSettings?.skipInvestments) {
        // Skip investments and go directly to incidents
        setGamePhase('gameplay');
        navigate('/incidents');
      } else {
        setGamePhase('investments');
        navigate('/investments');
      }
    } else {
      console.warn('Please enter your name and company name before proceeding.');
    }
  };

  const navigateToIncidents = () => {
    if (canProceedFromInvestments()) {
      setGamePhase('gameplay');
      navigate('/incidents');
    } else {
      console.warn('Please select at least one investment before proceeding.');
    }
  };

  const navigateToScoring = () => {
    if (canProceedFromIncidents()) {
      setGamePhase('scoring');
      navigate('/scoring');
    } else {
      console.warn('Please respond to all incidents before proceeding.');
    }
  };

  const navigateToDecisionAnalysis = () => {
    setGamePhase('decision-analysis');
    navigate('/decision-analysis');
  };

  const navigateToSummary = () => {
    setGamePhase('summary');
    navigate('/summary');
  };

  const navigateToScenarios = () => {
    setGamePhase('scenario-selection');
    navigate('/scenarios');
  };

  const startNewGame = () => {
    resetGame();
    navigate('/');
  };

  return {
    canProceedFromCEO,
    canProceedFromInvestments,
    canProceedFromIncidents,
    navigateToCEO,
    navigateToInvestments,
    navigateToIncidents,
    navigateToScoring,
    navigateToDecisionAnalysis,
    navigateToSummary,
    navigateToScenarios,
    startNewGame,
  };
};